export const VonEmployeeRestrictionType = {
    AllowedRoles: 0,
    DoesNotConsumeLicense: 1,
    NotAllowedRoles: 2,
    MaxNumberOfEmployees: 3,
    NotAllowedAsOnlyType: 4,
    HiddenForCustomer: 5,
    AllowedEmployeeTypePerCountry: 6
};